import script from "./MenuDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuDesktop.vue?vue&type=script&setup=true&lang=js"

import "./MenuDesktop.vue?vue&type=style&index=0&id=962fe532&lang=scss"

const __exports__ = script;

export default __exports__